import { render, staticRenderFns } from "./Historical.vue?vue&type=template&id=ae6ac0da&scoped=true"
import script from "./Historical.vue?vue&type=script&lang=js"
export * from "./Historical.vue?vue&type=script&lang=js"
import style0 from "./Historical.vue?vue&type=style&index=0&id=ae6ac0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6ac0da",
  null
  
)

export default component.exports